import { ChipsInput } from '@prismamedia/one-components';
import { isDefined } from '../../../utils/isDefined';
import { FC } from 'react';
import {
  ArticleFormat,
  ArticleStatus,
} from '../../../__generated__/queries-web';
import { statuses } from '../../../utils/statuses';

const articleStatus = [
  ArticleStatus.Published,
  ArticleStatus.Scheduled,
  ArticleStatus.ScheduledForRepublication,
  ArticleStatus.Ready,
  ArticleStatus.Frozen,
  ArticleStatus.Draft,
  ArticleStatus.Deleted,
].map((status) => ({
  id: status,
  label: statuses(ArticleFormat.Rich)[status].label,
  color: statuses(ArticleFormat.Rich)[status].color,
}));

interface StatusesSelectProps {
  label: string;
  className?: string;
  value?: ArticleStatus[];
  onChange?: (value?: ArticleStatus[]) => void;
}

export const StatusesSelect: FC<StatusesSelectProps> = ({
  label,
  className,
  value,
  onChange,
}) => {
  const fetchList = async (search: string) =>
    articleStatus.filter(({ label: statusLabel }) =>
      statusLabel.includes(search),
    );

  const internalValue = value
    ?.map((val) => articleStatus.find(({ id }) => id === val))
    .filter(isDefined);

  return (
    <ChipsInput
      variant="outlined"
      label={label}
      value={internalValue}
      className={className}
      onChange={(val) =>
        onChange?.(
          val?.length ? val.map(({ id }) => id as ArticleStatus) : undefined,
        )
      }
      autocomplete={{ fetchList }}
    />
  );
};
